const loyaltyHelper = {
    isBurnEligible(data) {
        return (
            data &&
            data.labels &&
            data.labels.acceptBurnLabel &&
            data.labels.declineBurnLabel &&
            data.labels.acceptBurnSublabel &&
            data.labels.declineBurnSublabel &&
            data.accountDetails &&
            data.accountDetails.redeemEligible &&
            data.accountDetails.balanceInCurrency > 0
        );
    },
};

export default loyaltyHelper;
